// extracted by mini-css-extract-plugin
export var acceptButton = "_1n-5";
export var fullContent = "_1n-4";
export var link = "_1n-6";
export var linkIcon = "_1n-7";
export var sideContent = "_1n-3";
export var sideImage = "_1n-2";
export var sideImageWrapper = "_1n-1";
export var splitLayout = "_1n-0";